import React from 'react';

// Shown on a buffer slot whose calendar event has no description (no court number)
export const DEFAULT_VENUE = 'Amara Hotel, 165 Tg Pagar Rd';

// Known venues. The calendar writes the whole address into the Description or
// Location (e.g. "Court Amara Hotel, 165 Tg Pagar Rd, Singapore 088539"); when
// one of these is recognised, the card shows the short label instead of that text.
const VENUES = [
  { pattern: /fortune\s*cent(er|re)/i, label: 'Fortune Center, Bugis' },
  { pattern: /amara\s*hotel/i, label: 'Amara Hotel, 165 Tg Pagar Rd' }
];
const findVenue = (...texts) => {
  const joined = texts.filter(Boolean).join(' ');
  const hit = VENUES.find(v => v.pattern.test(joined));
  return hit ? hit.label : null;
};

// The calendar often puts the court AND the whole address in one string, e.g.
// "Court 3 Fortune Centre, 190 Middle Rd, Level 6B, Singapore 188979 -".
// Pull just the court number out so the court and the venue can be shown on
// their own lines. Accepts "Court 3", "court3" or a leading bare "3".
function courtFrom(text) {
  const t = String(text || '');
  const m = t.match(/court\s*(\d+)/i) || t.match(/^\s*(\d+)\b/);
  return m ? `Court ${m[1]}` : null;
}

/**
 * Court + venue block for a slot, identical everywhere a slot is shown
 * (player's browse cards and booking cards, coach's slot list and request cards):
 *
 *   🏟️ Court 2                  <- the buffer event's Description (court number)
 *   📍 Fortune Center, Bugis     <- when the event's Location is Fortune Center
 *
 * With no court number and no Fortune location, a buffer slot shows the default
 * venue. Non-buffer slots with a description keep showing it as a plain note.
 * `slot` may be a booking's populated slotId; anything not an object renders nothing.
 */
export default function SlotCourtInfo({ slot, margin = '8px 0' }) {
  if (!slot || typeof slot !== 'object') return null;

  // Fortune Center can be named in the event's Location OR (as the calendar
  // often has it) inside the Description text itself
  const venue = findVenue(slot.location, slot.description);
  const isBuffer = slot.sourceType === 'buffer';

  if (!isBuffer && !venue) {
    return slot.description ? (
      <div style={{ fontSize: '12px', color: '#7f8c8d', margin }}>📝 {slot.description}</div>
    ) : null;
  }

  let court;
  if (venue) {
    // Whole address in the text -> keep only the court number (if there is one)
    court = courtFrom(slot.description);
  } else {
    court = slot.description
      ? (/court/i.test(slot.description) ? slot.description : `Court ${slot.description}`)
      : null;
  }

  if (!court && !venue && !isBuffer) return null;

  return (
    <div style={{ fontSize: '13px', color: '#2c3e50', margin, fontWeight: 600 }}>
      {court && <div>{`🏟️ ${court}`}</div>}
      {venue
        ? <div style={{ fontWeight: 500 }}>{`📍 ${venue}`}</div>
        : (!court && <div>{`📍 ${DEFAULT_VENUE}`}</div>)}
    </div>
  );
}
